import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=6b81ae47"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"
import style0 from "./Layout.vue?vue&type=style&index=0&id=6b81ae47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports